document.addEventListener('DOMContentLoaded', function () {
    $('.vip-mobile-box .top').click(function () {
        if ($(this).next('.bottom').is(':hidden')) {
            $(this).addClass('active');
        } else {
            $(this).removeClass('active');
        }
        $(this).next('.bottom').slideToggle();
    });
});